$(document).ready(function(){
  $('.js-load-more').on('click', function () {
    var $this = $(this),
        totalPages = parseInt($('[data-total-pages]').val()),
        currentPage = parseInt($('[data-current-page]').val());

    // Increment page number before generating nextUrl
    var nextPage = currentPage + 1;

    // Disable button and show loader
    $this.attr('disabled', true);
    $this.find('[load-more-text]').addClass('hide');
    $this.find('[loader]').removeClass('hide');
    var fullUrl = $('[data-next-url]').val().split('?page=');
    if (window.location.pathname.indexOf('/collections') === 0) {
      var nextUrl = fullUrl[0] + '?page=' + nextPage;
    } else {
      var nextUrl = $('[data-next-url]').val().replace(/page=\d+/, 'page=' + nextPage);
    }

    // console.log(nextUrl)
    

    $.ajax({
      url: nextUrl,
      type: 'GET',
      dataType: 'html',
      success: function (responseHTML) {
        // Append new content
        $('#ProductGridContainer #product-grid.product-grid').append($(responseHTML).find('#ProductGridContainer #product-grid.product-grid').html());

        // Update current page
        $('[data-current-page]').val(nextPage);
        // console.log(responseHTML);
        // Prepare next URL only if more pages exist
        if (nextPage < totalPages) {
          var newNextUrl = nextUrl.replace(/page=\d+/, 'page=' + (nextPage + 1));
          $('[data-next-url]').val(newNextUrl);
        } else {
          // Optionally hide or disable the button if all pages are loaded
          $this.hide();
        }
      },
      complete: function () {
        if (nextPage <= totalPages) {
          $this.attr('disabled', false);
          $this.find('[load-more-text]').removeClass('hide');
          $this.find('[loader]').addClass('hide');
        }
      }
    });
  });
  const toggleButton = document.querySelector(".read-more-toggle");
  const textSpan = document.querySelector(".read-more-text");

  // if (fulltext && toggleButton) {
  //     const heightThreshold = '72px'; 
  //     const actualHeight = fulltext.offsetHeight;
  //     if (actualHeight >= heightThreshold) {
  //       toggleButton.style.display = "block!important";
  //     } else {
  //       toggleButton.style.display = "none";
  //     }
  //   }
  if(toggleButton){
      toggleButton.addEventListener("click", function () {
      textSpan.classList.toggle("expanded");
      toggleButton.textContent = textSpan.classList.contains("expanded") ? "Read less" : "Read more";
    });
  }
  
  $('.slideshow').slick({
    slidesToShow: 1,
    dots:$('.slideshow').attr('data-dots') === 'true',
    arrows: $('.slideshow').attr('data-arrow') === 'true',
    touchThreshold: 500,
    autoplay:$('.slideshow').attr('data-autoplay') === 'true',
    autoplaySpeed:$('.slideshow').attr('data-speed'),
    infinite: false
  });

  // document.querySelectorAll('.slideshow').forEach(slider => {
  //   customSlider(slider, {
  //     slidesToShow: 1,
  //     dots: slider.dataset.dots === 'true',
  //     arrows: slider.dataset.arrow === 'true',
  //     autoplay: slider.dataset.autoplay === 'true',
  //     autoplaySpeed: parseInt(slider.dataset.speed) || 3000,
  //     touchThreshold: 500,
  //     gap: 0,
  //     infinite: false,
  //     responsive: [
  //       {
  //         breakpoint: 768,
  //         settings: { slidesToShow: 1 }
  //       },
  //       {
  //         breakpoint: 1024,
  //         settings: { slidesToShow: 1 }
  //       }
  //     ]
  //   });
  // });
  
  $('.announcement-bar-container.multi-bar').slick({
    slidesToShow: 1,
    dots:false,
    arrows: false,
    touchThreshold: 500,
    autoplay:true,
    infinite: true
  });
  // document.querySelectorAll('.announcement-bar-container.multi-bar').forEach(bar => {
  //   customSlider(bar, {
  //     slidesToShow: 1,
  //     slidesToScroll: 1,
  //     dots: false,
  //     arrows: false,
  //     autoplay: true,
  //     gap: 0,
  //     autoplaySpeed: 3000,
  //     infinite: true,
  //     touchThreshold: 500,
  //     responsive: [
  //       {
  //         breakpoint: 1024,
  //         settings: { slidesToShow: 1 }
  //       },
  //       {
  //         breakpoint: 768,
  //         settings: { slidesToShow: 1 }
  //       }
  //     ]
  //   });

  // });

  $('.feature_collection').each(function() {
    var section_id = $(this).attr('data-id');
    var $slider = $('.feature_collection[data-id="'+section_id+'"] .collection slider-component .slider');
    
    $slider.slick({
      slidesToShow: parseInt($slider.attr('data-desk-slide'), 10),
      dots: true,
      arrows: true,
      slidesToScroll: 1,
      touchThreshold: 500,
      responsive: [
          {
              breakpoint: 991,
              settings: {
                  slidesToShow: 2,
              }
          },
          {
              breakpoint: 767,
              settings: {
                  slidesToShow: parseInt($slider.attr('data-mob-slide'), 10),
              }
          }
      ]
    });
    
    setTimeout(function() {
        $slider.slick('setPosition');
    }, 100);
  });

  // document.querySelectorAll('.feature_collection').forEach(section => {
  //   const sectionId = section.getAttribute('data-id');

  //   const slider = document.querySelector(
  //     `.feature_collection[data-id="${sectionId}"] .collection slider-component .slider`
  //   );

  //   if (!slider) return;

  //   const deskSlides = parseInt(slider.getAttribute('data-desk-slide'), 10) || 1;
  //   const mobSlides  = parseInt(slider.getAttribute('data-mob-slide'), 10) || 1;

  //   customSlider(slider, {
  //     slidesToShow: deskSlides,
  //     dots: true,
  //     arrows: true,
  //     slidesToScroll: 1,
  //     touchThreshold: 500,
  //     infinite: false,
  //     responsive: [
  //       {
  //         breakpoint: 991,
  //         settings: {
  //           slidesToShow: 2
  //         }
  //       },
  //       {
  //         breakpoint: 767,
  //         settings: {
  //           slidesToShow: mobSlides
  //         }
  //       }
  //     ]
  //   });
  // });

  // document.querySelectorAll('.feature_collection').forEach(section => {

  //   const slider = section.querySelector(
  //     '.collection slider-component .slider'
  //   );

  //   if (!slider) return;

  //   const deskSlides = parseInt(slider.dataset.deskSlide, 10) || 1;
  //   const mobSlides  = parseInt(slider.dataset.mobSlide, 10) || 1;

  //   customSlider(slider, {
  //     slidesToShow: deskSlides,
  //     slidesToScroll: 1,
  //     dots: false,
  //     arrows: true,
  //     infinite: false,
  //     touchThreshold: 500,
  //     responsive: [
  //       {
  //         breakpoint: 991,
  //         settings: { slidesToShow: 2 }
  //       },
  //       {
  //         breakpoint: 767,
  //         settings: { slidesToShow: mobSlides }
  //       }
  //     ]
  //   });

  // });


  var $slider = $('.featured_blog .blog__posts');
  
  $slider.slick({
    slidesToShow: parseInt($slider.attr('data-desk-slide'), 10),
    dots: true,
    arrows: false,
    slidesToScroll: 1,
    touchThreshold: 500,
    responsive: [
      {
        breakpoint: 990,
        settings: {
          slidesToShow: 2,
        }
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 1,
        }
      }
    ]
  });

  // document.querySelectorAll('.featured_blog').forEach(section => {
  //   const slider = section.querySelector('.blog__posts');
  //   if (!slider) return;

  //   const deskSlides =
  //     parseInt(slider.getAttribute('data-desk-slide'), 10) || 1;

  //   customSlider(slider, {
  //     slidesToShow: deskSlides,
  //     slidesToScroll: 1,
  //     dots: true,
  //     arrows: false,
  //     touchThreshold: 500,
  //     infinite: false,
  //     responsive: [
  //       {
  //         breakpoint: 990,
  //         settings: {
  //           slidesToShow: 2
  //         }
  //       },
  //       {
  //         breakpoint: 767,
  //         settings: {
  //           slidesToShow: 1
  //         }
  //       }
  //     ]
  //   });
  // });
    
});

document.addEventListener('DOMContentLoaded', () => {
  const accordions = document.querySelectorAll('.grid__item .accordion');

  const animateOpen = (content) => {
    content.style.opacity = 1;
    const height = content.scrollHeight;

    content.style.transition = 'all 300ms ease';
    content.style.height = '0px';

    requestAnimationFrame(() => {
      content.style.height = height + 'px';
    });

    setTimeout(() => {
      content.style.height = 'auto';
    }, 300);
  };

  const animateClose = (content) => {
    const height = content.scrollHeight;

    content.style.height = height + 'px';
    content.style.transition = 'all 300ms ease';

    requestAnimationFrame(() => {
      content.style.height = '0px';
    });

    setTimeout(() => {
      content.style.opacity = 0;
    }, 300);
  };

  accordions.forEach((accordion) => {
    const details = accordion.querySelector('details');
    const summary = accordion.querySelector('summary');
    const content = accordion.querySelector('.accordion__content');

    // Initial state
    if (details.hasAttribute('open')) {
      content.style.height = 'auto';
      summary.setAttribute('aria-expanded', 'true');
    }

    summary.addEventListener('click', (e) => {
      e.preventDefault();

      const isOpen = details.hasAttribute('open');

      // Close all others
      accordions.forEach((other) => {
        const d = other.querySelector('details');
        const s = other.querySelector('summary');
        const c = other.querySelector('.accordion__content');

        if (d !== details && d.hasAttribute('open')) {
          d.removeAttribute('open');
          animateClose(c);
          s.setAttribute('aria-expanded', 'false');
        }
      });

      // Toggle current
      if (!isOpen) {
        details.setAttribute('open', '');
        animateOpen(content);
        summary.setAttribute('aria-expanded', 'true');
      } else {
        details.removeAttribute('open');
        animateClose(content);
        summary.setAttribute('aria-expanded', 'false');
      }
    });
  });
});